<template>
  <div class="mb-solution">
    <div class="solution1">
      <img :src="require('@/assets/mobile/solution1.png')"/>
      <div class="desc">
        <p>智慧充电<span>云</span>平台</p>
        <p>互联互通，创造智能充电云时代</p>
      </div>
    </div>
    <div class="solution2">
      <div class="desc">
        <p>国恒充电<span>APP</span></p>
        <p>新能源汽车充电助手，集充电、预约、支付等功能让充电随手可得，简单方便</p>
      </div>
      <div class="desc1">
        <div class="saoma">
          <img :src="require('@/assets/mobile/saoma.png')"/>
          <div class="hd">扫码充电</div>
          <div>扫描充电桩上二维码，</div>
          <div>开启充电之旅</div>
        </div>
        <div class="yuyue">
          <img :src="require('@/assets/mobile/yuyue.png')"/>
          <div class="hd">智能预约</div>
          <div>预约低谷电价，</div>
          <div>省钱省心</div>
        </div>
        <div class="zhifu">
          <img :src="require('@/assets/mobile/zhifu.png')"/>
          <div class="hd">快捷支付</div>
          <div>绑定支付宝，微信支付，</div>
          <div>简单放心</div>
        </div>
      </div>
      <div class="bg">
        <img :src="require('@/assets/mobile/solution2.png')"/>
      </div>
    </div>
    <div class="solution3">
      <div class="desc">
        <p class="title">系统部署方案</p>
        <p class="title1">在云端部署智慧充电云平台，降低本地部署成本；在变压器低压侧增加智能电表，减少对现有电力的改造成本。智慧充电云平台支持对变压器、充电桩的负载数据进行实时分析，自动根据居民用电峰谷情况，调节充电桩的输出功率，实现居民用电优先。</p>
        <p></p>
      </div>
      <img class="bg" :src="require('@/assets/mobile/solution3.png')"/>
    </div>
    <div class="solution4">
      <div class="desc">
        <p class="title">电力部署方案</p>
        <p class="title1">利用小区现有供电容量，从小区变压器布线至停车场配电箱，根据业主的充电需求，就近从配电箱布线至停车位，并安装充电盒。</p>
      </div>
      <div class="prompt">
        <div class="fugai">
          <img :src="require('@/assets/mobile/fugai.png')"/>
          <div class="hd">整体覆盖</div>
          <div>均匀布线，停车场全覆盖，</div>
          <div>满足所有车位报装需求</div>
        </div>
        <div class="anzhuang">
          <img :src="require('@/assets/mobile/anzhuang.png')"/>
          <div class="hd">按需安装</div>
          <div>根据业主需求，从离业主车</div>
          <div>位最近的配电箱接线安装</div>
        </div>
        <div class="jiyong">
          <img :src="require('@/assets/mobile/jiyong.png')"/>
          <div class="hd">即装即用</div>
          <div>业主当天申请、当天安装、</div>
          <div>当天使用</div>
        </div>
        <div class="guanli">
          <img :src="require('@/assets/mobile/guanli.png')"/>
          <div class="hd">集中管理</div>
          <div>云平台集中管控、实现充电设</div>
          <div>备统一管理，保障充电安全</div>
        </div>
      </div>
      <img class="bg" :src="require('@/assets/mobile/solution4.png')"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'solution'
}
</script>
<style lang="less">
.mb-solution{
  width: 100%;
  >div{
    width: 100%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
    p{
      word-break: break-all;
    }
  }
  .solution1{
    height: 11.58rem;
    .desc{
      width: 100%;
      position: absolute;
      top: 1.6rem;
      left: 0;
      text-align: center;
      p{
        &:first-child{
          font-size: 27px;
          line-height: 30px;
          color: #292929;
          margin-bottom: .5rem;
          span{
            color: #78D7D1;
          }
        }
        &:last-child{
          font-size: 16px;
          line-height: 20px;
          color: #666;
        }
      }
    }
  }
  .solution2{
    background: white;
    padding: 1rem 0 0;
    .desc{
      width: 100%;
      text-align: center;

      >p{
        text-align: center;
        &:first-child{
          font-size: 24px;
          color: #292929;
          span{
            color: #78D7D1;
          }
        }
        &:last-child{
          padding: 0 1.2rem;
          font-size: 14px;
          line-height: 18px;
          color: #666;
          margin: .3rem 0 .78rem;
        }
      }
    }
    .desc1{
      display: flex;
      justify-content: space-around;
      margin-bottom: .8rem;
      >div{
        text-align: center;
        &.saoma, &.zhifu{
          flex: 0 0 136px;
        }
        &.yuyue{
          flex: 0 0 85px;
        }
        >img{
          width: .55rem;
          height: .55rem;
        }
        >div{
          font-size: 12px;
          line-height: 16.5px;
          color: #999;
          &.hd{
            font-size: 14px;
            line-height: 20px;
            color: #333;
          }
        }
      }
    }
    .bg{
      margin: 0 auto;
      width: 5.22rem;
      height: 7.18;
    }
  }
  .solution3{
    .desc{
      width: 100%;
      text-align: center;
      .title{
        font-size: 24px;
        line-height: 33.5px;
        color: #292929;
      }
      .title1{
        text-align: left;
        padding: .37rem .5rem .5rem;
        font-size: 14px;
        line-height: 20px;
        color: #666;
      }
    }
    .bg{
      width: 6.77rem;
      height: 9.7rem;
      margin: 0 auto;
    }
  }
  .solution4{
    .desc{
      width: 100%;
      text-align: center;
      .title{
        margin-top: 1.5rem;
        font-size: 24px;
        line-height: 33.5px;
        color: #292929;
      }
      .title1{
        text-align: left;
        padding: .23rem .26rem .74rem;
        font-size: 14px;
        line-height: 20px;
        color: #666;
      }
    }
    .prompt{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      >div{
        text-align: center;
        &.fugai, &.anzhuang, &.jiyong{
          flex: 0 0 145px;
        }
        &.guanli{
          flex: 0 0 162px;
        }
        &.anzhuang{
          >img{
            height: .4rem;
            line-height: .55rem;
          }
        }
        &.guanli{
          >img{
            height: .44rem;
            line-height: .55rem;
          }
        }
        >img{
          width: .55rem;
          height: .55rem;
        }
        >div{
          font-size: 12px;
          line-height: 16.5px;
          color: #999;
          text-align: left;
          &.hd{
            text-align: center;
            color: #333;
          }
        }
      }
    }
    .bg{
      width: 7.15rem;
      height: 4.25rem;
      margin: .85rem auto 1.23rem;
    }
  }
}
</style>
